import React, { FC } from 'react';
import LazyLoad from 'react-lazyload';
import { NEXT_PUBLIC_PERCY_RUN } from 'src/env';

// constants
import { LAZY_OFFSET } from 'src/lib/constants';

interface Props {
  isLazy?: boolean;
  children: React.ReactNode;
  offset?: number;
  scrollContainer?: string | React.ReactNode;
  height?: string | number;
}

const Lazy: FC<Props> = ({
  children,
  isLazy = true,
  offset = LAZY_OFFSET,
  scrollContainer,
  height = null,
}) => {
  const shouldLazyLoad = NEXT_PUBLIC_PERCY_RUN ? false : isLazy;
  return shouldLazyLoad ? (
    <LazyLoad
      once
      offset={offset}
      height={height || '100%'}
      scrollContainer={scrollContainer}
    >
      {children}
    </LazyLoad>
  ) : (
    <>{children}</>
  );
};

export default Lazy;
